import React from "react"
import { CircularProgress } from "../utils/ui";

export default function PageLoader() {
    return (
        <div style={{ position: 'fixed', left: '50%', top: '30%', transform: 'translate(-50%, 0)' }}><CircularProgress /></div> 
    )
}
